import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { ICollectiveDirectoryPersonDrawerResponse } from 'interfaces';
import { getPersonDrawer } from 'services/app';

import { IPersonCard } from '../PeopleContent/PeopleList/NewPersonCard';

export default function useCollectiveIndexPersonDrawer(
  uuid: string,
  matches?: IPersonCard['matched_detail'],
  options?: Omit<
    UseQueryOptions<
      ICollectiveDirectoryPersonDrawerResponse,
      Error,
      ICollectiveDirectoryPersonDrawerResponse,
      QueryKey
    >,
    'queryKey'
  >
) {
  return useQuery<ICollectiveDirectoryPersonDrawerResponse, Error>(
    [`collective-index-person-drawer`, uuid, matches],
    () =>
      getPersonDrawer(uuid, matches).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message);
        }
        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
